module.exports = __webpack_public_path__ + "img/complete.fb35c1d4.png";